// extracted by mini-css-extract-plugin
export default {"TitleHolder":"AddCommentUserPanel_TitleHolder__WoG2I"};